import { authHeader } from "../helpers/auth-header";
import {
    handleResponse,
    handleResponseLogin
} from "../helpers/handle-response";

let BACKEND_API = process.env.VUE_APP_BACKEND_API;

export const userService = {
    login,
    login2fa,
    logout,
    getAll
};

function login(username, password) {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ username: username, password: password })
    };

    return fetch(`${BACKEND_API}/api/authenticate`, requestOptions)
        .then(handleResponseLogin)
        .then(user => {
            return user;
        });
}


function login2fa(username, password, code) {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ username: username, password: password, code: code })
    };
    return fetch(`${BACKEND_API}/api/2fa_check`, requestOptions)
        .then(handleResponseLogin)
        .then(user => {
            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("instantcare_user");
    sessionStorage.clear();
}

function getAll() {
    const requestOptions = {
        method: "GET",
        headers: authHeader()
    };

    return fetch(`${BACKEND_API}/users`, requestOptions).then(handleResponse);
}
